var _defs, _title, _line, _path, _line2, _path2, _line3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlagWarning = function SvgFlagWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "flag-warning")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 23.25,
    x2: 0.75,
    y2: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75,20.293l3.154-.97a9.61,9.61,0,0,1,7.864,1,9.615,9.615,0,0,0,7.679,1.056l2.987-.853a1.126,1.126,0,0,0,.816-1.082V3.637a1.126,1.126,0,0,0-1.434-1.082l-2.369.677a9.615,9.615,0,0,1-7.679-1.056,9.61,9.61,0,0,0-7.864-1L.75,2.145"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 15.75,
    x2: 12,
    y2: 15.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,15.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,15.75"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 12.75,
    x2: 12,
    y2: 6.75
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag-warning.dca32524.svg";
export { ForwardRef as ReactComponent };